"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var settings_module_1 = require("./settings.module");
exports.SettingsModule = settings_module_1.SettingsModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/settings/index.js
// module id = ../../../../../src/app/packages/menu-items/settings/index.js
// module chunks = main